import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    integrations: [
      // Temporarily disabled for now:
      // Sentry.browserTracingIntegration(),
      // Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration(),
    ],
    // v11 collects request and response bodies, cookies, headers and the user's IP address unless told otherwise. This is
    // v10's default, which this app has always run with: no bodies, no cookies or IP address, headers and query
    // parameters without the ones that identify the user.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: {
        request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
      httpBodies: [],
      urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      genAI: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      graphQL: { document: false, variables: false },
    },
    // Temporarily disabled for now:
    // tracesSampleRate: 0.2,
    // replaysSessionSampleRate: 1,
    // replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
